<template>
  <div class="why">
    <h2>Why are you the ideal candidate?</h2>
    <!-- <p class="highlight-text">Please complete the following section by telling us why you are the ideal candidate to become a Trailfinders Travel Expert and also where you heard about this opportunity.</p> -->
    <!-- Form -->
    <b-form>
      <!-- Why -->
      <b-form-group
        :label="generateLabel(recruit.why, 'What will make you a successful sales consultant?*')"
      >
        <b-form-textarea
          :value="recruit.why"
          @input="handleInput('why', $event, true)"
          :class="{
            'is-valid': !$v.recruit.why.$error && recruit.why,
            'is-invalid': $v.recruit.why.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- How -->
      <b-form-group
        label="How did you hear about this job opportunity*"  
      >
        <b-form-select
          :value="recruit.hearabout"
          :options="howOpts"
          @change="handleInput('hearabout', $event, true)"
          :class="{
            'is-valid': !$v.recruit.hearabout.$error && recruit.hearabout,
            'is-invalid': $v.recruit.hearabout.$error
          }"
        ></b-form-select>
      </b-form-group>
      <!-- The following are displayed depending on which option is selected -->
      <!-- On which site -->
      <b-form-group
        v-if="recruit.hearabout === 'Online Job Search'"
        label="Which website did you see the ad on? (please be as specific as possible)?"
      >
        <b-form-textarea
          :value="recruit.hearaboutSearch"
          @input="handleInput('hearaboutSearch', $event)"
          :class="{
            'is-valid': !$v.recruit.hearaboutSearch.$error && recruit.hearaboutSearch,
            'is-invalid': $v.recruit.hearaboutSearch.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- How did you hear -->
      <b-form-group
        v-if="recruit.hearabout === 'Other'"
        label="How did you hear about TF (please be as specific as possible)?"
      >
        <b-form-textarea
          :value="recruit.hearaboutOther"
          @input="handleInput('hearaboutOther', $event)"
          :class="{
            'is-valid': !$v.recruit.hearaboutOther.$error && recruit.hearaboutOther,
            'is-invalid': $v.recruit.hearaboutOther.$error
          }"
        ></b-form-textarea>
      </b-form-group>
      <!-- Confirmation -->
      <!-- <b-form-group>
        <div class="checkbox checkbox-custom">
          <input id="candidate-confirm" 
            name="candidate-confirm" 
            type="checkbox" 
            :value="recruit.confirm"
            v-model="confirm"
            required
            @change="handleInput('confirm', $event.target.checked, true)"
          >
          <label for="candidate-confirm">I confirm that I have read the <a href="/staff-personspecification" target="_blank">Person Specification</a> and <a href="/staff-jobdescription" target="_blank">Job Description</a>*</label>
          <b-alert v-if="$v.recruit.confirm.$error" show variant="danger">
            <p>You must tick this box in order to submit the application</p>
          </b-alert>
        </div>
      </b-form-group>  -->
      <!-- <BtnMain @btnClicked="handleProgress" text="Save and progress" btnClass="progress-btn" variant="dark" /> -->
    </b-form>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { updateForm } from '../../helpers/index'
// import BtnMain from '../../components/BtnMain'
import { required, requiredIf, minLength } from 'vuelidate/lib/validators'
export default {
  components: {
    // BtnMain
  },
  computed: {
    ...mapState({recruit: state => state.authStore.recruit}),
    ...mapGetters({
      getRecruit: 'authStore/getRecruit',
      getSectionOpen: 'authStore/getSectionOpen'
    })
  },
  data () {
    return {
      howOpts: [{ text: 'Please select', value: null }, 'Online Job Search', 'I searched for jobs on Glassdoor', 'I am a previous Trailfinders Client', 'The advert in the Trailfinders Magazine', 'I spotted your ad on trailfinders.com while researching holidays', 'Recommended by a Trailfinders member of staff or a Trailfinders client', 'Other'],
      confirm: ''
    }
  },
  mounted () {
    this.$v.$touch()
    // Set currStillEmployed on load - this is required to display checked boxes in accordance with whats saved in mongo
    this.confirm = this.recruit.confirm
  },
  updated () {
    // Pass validation status to vuex
    const validationData = {
      section: 'why',
      status: !this.$v.recruit.$invalid
    }
    this.updateApplicationCompleteAction(validationData)
  },
  methods: {
    ...mapActions({
      updateRecruitAction: 'authStore/updateRecruitAction',
      sectionOpenAction: 'authStore/sectionOpenAction',
      updateBelfastSelectedAction: 'authStore/updateBelfastSelectedAction',
      updateApplicationCompleteAction: 'authStore/updateApplicationCompleteAction'
    }),
    handleInput (input, e, required) {
      this.updateForm(input, e)

       // If field is required run veulidate validation - to apply classes to input not to prevent user from saving
      if (required) {
        this.$v.recruit[input].$touch()
      }
    },
    updateForm,
    generateLabel(field, label){
       if (field.length < 300){
        label += ' (min 300 characters)'
      } 
      return label
    }
  },
  validations () {
    return {
      recruit: {
      why: {
        required: required,
        minLengthValue: minLength(300)
      },
      hearabout: {
        required: required
      },
      hearaboutSearch: {
        required: requiredIf(() => this.recruit.hearabout === 'Online Job Search')
      },
      hearaboutOther: {
        required: requiredIf(() => this.recruit.hearabout === 'Other')
      },
      // confirm: {
      //   sameAs: sameAs(() => true)
      // }
    }
    }
  }
}
</script>

<style scoped>

</style>